import { del, get, put } from '../../utils/axios'
const path = '/attendance-notify'

export const getAttendanceNotiAPI = async (params) => {
  return await get(`${path}`, params)
}
export const getDetailAttendanceNotiAPI = async (params) => {
  return await get(`${path}/detail`, params)
}
export const getSearchUserAPI = async (params) => {
  return await get(`${path}/search/user/th-eng`, params)
}
export const getSearchLineGAPI = async (params) => {
  return await get(`${path}/line-group`, params)
}
export const putNotiUserDetailsAPI = async (body) => {
  return await put(`${path}/user`, {}, body)
}
export const putNotiGroupDetailsAPI = async (body) => {
  return await put(`${path}/notify`, {}, body)
}
export const delNotiAPI = async (body) => {
  return await del(`${path}`, {}, body)
}
export const getCheckUrlLarkGAPI = async (params) => {
  return await get(`${path}/check/lark-url`, params)
}
